module.exports = __webpack_public_path__ + "static/media/jesse_face_screen-sm.d1a47de7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/jesse_face_screen-sm.jpg
// module id = 719
// module chunks = 0